import ShippingMethodsModal from './ShippingMethodsModal';

export default ShippingMethodsModal;
